document.addEventListener("DOMContentLoaded", () => {

    const STORAGE_KEY = "tkcWishlist";

    const getWishlist = () => {

        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

    };

    const saveWishlist = (items) => {

        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));

    };

    const updateButtons = () => {

        const items = getWishlist();

        document.querySelectorAll(".tkc-wishlist-btn").forEach(btn => {

            const handle = btn.dataset.productHandle;

            btn.classList.toggle("is-active", items.includes(handle));

        });

    };

    document.addEventListener("click", (e) => {

        const btn = e.target.closest(".tkc-wishlist-btn");

        if (!btn) return;

        const handle = btn.dataset.productHandle;

        let items = getWishlist();

        if (items.includes(handle)) {

            items = items.filter(item => item !== handle);

        } else {

            items.push(handle);

        }

        saveWishlist(items);

        updateButtons();

    });

    updateButtons();

});